import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// Onboarding route guard — sends already-onboarded users to the dashboard
// instead of looping them back through onboarding.
export const OnboardingRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  if (user?.onboardingCompleted) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
};
